export interface CreditGateState {
  checked: boolean
  loading: boolean
  signedIn: boolean
  usageLoading: boolean
  availableCredits: number | undefined
}

// What RequireCredits shows. It waits until the session and the first usage fetch land: rendering the
// creation surface first means an out-of-credits user watches it paint and then get replaced by the plan
// picker. A zero-or-less balance gates; no balance (a usage outage) lets the user through.
export function creditGate({ checked, loading, signedIn, usageLoading, availableCredits }: CreditGateState): 'loading' | 'gate' | 'open' {
  if (!checked || loading || (signedIn && usageLoading)) return 'loading'
  if (availableCredits !== undefined && availableCredits <= 0) return 'gate'
  return 'open'
}
